import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./tags.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const addTagEndPoints = ApiEndpoints.tags.tagCreate;
export default function AddTags() {
  const [name, setName] = useState("");
  const navigate = useNavigate();

  const handleInputChange = useCallback((e) => {
    setName(e.target.value);
  }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      const payload = { name };

      try {
        await ApiRequest("POST", addTagEndPoints, payload);
        navigate("/admin/tags"); 
      } catch (error) {
        console.error("There was an error creating the tag!", error);
        alert("There was an error creating the tag!");
      }
    },
    [name, navigate]
  );

  return (
    <>
      <div className="header-add-category">
        <h5>Add Tags</h5>
      </div>
      <div className="add-tag-content">
        <form onSubmit={handleSubmit}>
          <label>Name:</label>
          <input
            type="text"
            value={name}
            onChange={handleInputChange}
            required
            className="form-control"
          />
          <div className="submit-formbtn">
            <button type="submit" className="default-btn">
              submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
